<template>
<div class="t-default" :class="[{'t-default--no-scroll' : !isBodyScrollable}]">
    <Header :isWhite="isStartPage" :isOverlapping="isStartPage" :showBreadcrumbs="!isStartPage" v-bind="model.header" :loginPage="loginPage" :isLanguageSelectorOpen="isLanguageSelectorOpen" :isMenuOpen="isMenuOpen" :currentLanguage="currentLanguage"/>
    <GatedContentPage v-if="model.gated && !isValidated" :pageId="model.contentLink.id" :form="model.siteSettings.embededGateForm" @validated="validated" />
    <slot v-else :model="model"></slot>
    <Footer v-bind="{...model.footer, headerTop: {isLanguageSelectorOpen: isLanguageSelectorOpen, isMenuOpen: isMenuOpen, currentLanguage: currentLanguage, searchPage: searchPage, loginPage: loginPage}}"/>
    <redirect-alert v-if="redirected" :text="model.siteSettings.redirectText"></redirect-alert>
</div>
</template>

<script>
import { mapState } from 'vuex';
import Header from '@/Scripts/components/organisms/Header.vue';
import Footer from '@/Scripts/components/organisms/Footer.vue';
import RedirectAlert from '@/Scripts/components/organisms/RedirectAlert.vue';
import GatedContentPage from '@/Scripts/components/pages/GatedContentPage.vue';

export default {
    components: {
        Header,
        Footer,
        GatedContentPage,
        RedirectAlert,
    },
    props: ['model'],
    data() {
        return {
            unsubscribe: null,
            isValidated: false,
            redirected: false,
        };
    },
    methods: {
        validated: function () {
            this.isValidated = true;
        },
        isRedirected: function () {
            if (this.$el.parentNode.hasAttribute('data-redirect')) {
                this.redirected = this.$el.parentNode.getAttribute('data-redirect');
            }
        }
    },
    computed: {
        ...mapState({
            isLanguageSelectorOpen: state => state.appContext.isLanguageSelectorOpen,
            isMenuOpen: state => state.appContext.isMenuOpen,
            isBodyScrollable: state => state.appContext.isBodyScrollable
        }),
        currentLanguage: function () {
            if (this.model.header && this.model.header.languageLinks) {
                return this.model.header.languageLinks.find(x => x.isCurrentLanguage);
            }
            return {
                name: ''
            };
        },
        isStartPage: function () {
            if (this.model.contentType.length > 1 && this.model.contentType[1] === 'StartPage') {
                return true;
            }
            if (this.model.contentType.length > 1 && this.model.contentType[1] === 'EbookPage') {
                return true;
            }
            return false;
        },
        searchPage: function () {
            return this.model.header ? this.model.header.searchPage : '/';
        },
        loginPage: function () {
            return this.model.header ? this.model.header.externalLoginUrl : null;
        }
    },
    mounted() {
        // Updating title on page change
        this.unsubscribe = this.$store.subscribe((mutation, state) => {
            if (mutation.type === 'epiDataModel/UPDATE_MODEL') {
                document.title = mutation.payload.metaData && mutation.payload.metaData.metaTitle + ' - Crayon';
            }
        });
        this.isRedirected();
    },
    beforeDestroy() {
        this.unsubscribe();
    }
};
</script>

<style lang="scss">
.t-default {
    position: relative;
    overflow: hidden;

    &--no-scroll {
        height: 100vh;
        overflow-y: hidden;
    }
}
</style>
